import type {HttpClient} from '@sollapay/http-client';
import type {ApiResponse, FeatureFlagsDTO} from '@sollapay/types';

export const featureFlagsApi = {
  fetchFeatureFlags: async (client: HttpClient) =>
    client.get<ApiResponse<FeatureFlagsDTO>>('/feature-flags')
};
